//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Typography } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import translations from './Comment.translations'

export default {
  components: {
    Typography,
  },
  props: {
    currentReview: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translations: () => translations,

    hasName() {
      return this.currentReview.firstName || this.currentReview.lastName
    },

    fullName() {
      const { firstName = '', lastName = '' } = this.currentReview

      return `${firstName} ${lastName}`.trim()
    },

    displayComment() {
      return !isEmpty(this.currentReview.comment)
    },

    displayDate() {
      return !isEmpty(this.currentReview.dateReview)
    },
  },
}
